"use client"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import Header from "./Header"

export default function ContactForm() {
  const { t } = useTranslation("ContactForm")
  const [formData, setFormData] = useState({ name: "", email: "", message: "" })
  const [status, setStatus] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: "15e2ca50-ab1b-4034-8123-d9425a41fc4d",
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      })

      const result = await response.json()
      console.log("Web3Forms Response:", result)

      if (result.success) {
        setStatus(t("success"))
        setFormData({ name: "", email: "", message: "" })
      } else {
        console.error("Form submission failed:", result)
        setStatus(result.message || t("error"))
      }
    } catch (error) {
      console.error("Form submission error:", error)
      setStatus(t("error"))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="py-20 px-6">
        <div className="max-w-2xl mx-auto bg-white p-10 rounded-md shadow-lg border border-gray-200">
          <h2 className="text-3xl font-semibold text-center text-gray-900 mb-8">
            {mounted ? t("title") : "Contact Us"}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <input
              type="text"
              name="name"
              placeholder={mounted ? t("namePlaceholder") : "Your name"}
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-800"
            />
            <input
              type="email"
              name="email"
              placeholder={mounted ? t("emailPlaceholder") : "Your email"}
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-800"
            />
            <textarea
              name="message"
              placeholder={mounted ? t("messagePlaceholder") : "Your message"}
              rows={6}
              value={formData.message}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-800"
            />

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-blue-700 text-white font-medium py-3 px-5 rounded-md hover:bg-blue-800 transition-colors disabled:opacity-50"
            >
              {mounted ? (isSubmitting ? t("sending") : t("sendButton")) : "Send Message"}
            </button>
          </form>

          {status && (
            <p
              className={`mt-6 text-center text-sm ${
                status === t("success") ? "text-green-600" : "text-red-600"
              }`}
            >
              {status}
            </p>
          )}
        </div>
      </section>
    </div>
  )
}
